import React, { useEffect } from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import MainStore from "../stores/MainStore";
import DetailedFieldHolder from "./DetailedFieldHolder";
import getFieldsOptions from "./getFieldOptions";

const DetailedBar = ({ catSelected, objects, clicks, position }) => {
  function onFirstRatingClicked(rating) {}
  function onSecondRatingClicked(rating) {}
  const handleBoxTypes = useHandleBoxTypes();
  const [options, setOptions] = React.useState(null);
  const { player } = MainStore();

  useEffect(() => {
    const boxType = handleBoxTypes.getBoxType(objects.general.type);
    if (clicks) {
      if (objects[catSelected])
        setOptions(
          getFieldsOptions(
            handleBoxTypes,
            boxType,
            position,
            catSelected,
            objects[catSelected]?.type,
            objects,
            clicks,
            catSelected
          )
        );
      else {
        setOptions(null);
      }
    }
  }, [catSelected, clicks, objects]);

  return (
    <div
      className="divColumn"
      style={{ flex: 1, height: "100%", marginTop: "30px" }}
    >
      {options &&
        options.map((field, index) => (
          <DetailedFieldHolder
            fieldObject={field}
            key={field.field + index}
            type={objects.general.type}
          />
        ))}
      {!options && <NotText catSelected={catSelected} objects={objects} />}
    </div>
  );
};

const NotText = ({ catSelected, objects }) => {
  const textObj = {
    saved: `${objects.general.shortDescription} is not saved`,
    open: `${objects.general.shortDescription} is not opened`,
    history: `You Have no history in ${objects.general.shortDescription}`,
  };

  return (
    <div
      className="divColumn"
      style={{
        width: "80%",
        height: "100%",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <div
        className="divColumn"
        style={{
          height: "70%",
          textAlign: "center",
          justifyContent: "center",
          position: "relative",
          alignContent: "center",
        }}
      >
        <BackgroundDiv backgroundColor={"#2f2f2f"} opacity={0.4} />
        <div className="textBoldWhite" style={{ zIndex: 1, fontSize: "28px" }}>
          {textObj[catSelected]}
        </div>
      </div>
    </div>
  );
};

export default DetailedBar;
